export default {
  cake: {
    56: '0xb8b9e96e9576af04480ff26ee77d964b1996216e',
    97: '',
  },
  masterChef: {
    56: '0x775eeAD1076B149d5EB81065fCD18A3a5717085a',
    97: '',
  },
  wbnb: {
    56: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    97: '',
  },
  lottery: {
    56: '',
    97: '',
  },
  lotteryNFT: {
    56: '',
    97: '',
  },
  mulltiCall: {
    56: '0x1ee38d535d541c55c9dae27b12edf090c608e6fb',
    97: '0x67ADCB4dF3931b0C5Da724058ADC2174a9844412',
  },
  busd: {
    56: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
    97: '',
  },
  usdt: {
    56: '0x55d398326f99059ff775485246999027b3197955',
    97: '',
  },
  referral: {
    56: '0x55C30b95F8F4DCD8f671016Ccf61c5B6C001903F',
    97: '',
  },
}
